import {BaseApiTemplateService} from '../shared';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared';
import {AppletStoreHostnameContainerModel} from '../../../../../models';

@Injectable({providedIn: 'root'})
export class AppletStoreHostnameLinkService extends BaseApiTemplateService<AppletStoreHostnameContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-store-hostname-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-store-hostname-links';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-store-hostname-links';
    this.httpClient = http;
  }
}
